import { keyframes } from "goober";
import { useState } from "react";

type NavKind = "workspace" | "settings" | "admin";

// Each sidebar sits one level deeper than the last (back arrows walk left up
// the ladder), so entering a deeper one slides from the right and returning
// slides from the left.
const navDepth: Record<NavKind, number> = {
  workspace: 0,
  settings: 1,
  admin: 2,
};

let lastNavKind: NavKind | null = null;

// Sidebars remount on every page switch, so a plain mount animation would
// replay constantly; slide only when the sidebar kind actually changes.
export function useNavTransition(kind: NavKind): "left" | "right" | undefined {
  const [direction] = useState(() => {
    const previous = lastNavKind;
    lastNavKind = kind;
    if (previous === null || previous === kind) return undefined;
    return navDepth[kind] > navDepth[previous]
      ? ("right" as const)
      : ("left" as const);
  });
  return direction;
}

const slideFromRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(12px);
  }
  to {
    opacity: 1;
    transform: none;
  }
`;

const slideFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-12px);
  }
  to {
    opacity: 1;
    transform: none;
  }
`;

export const navEnterStyles = `
  &[data-nav-enter="right"] {
    animation: ${slideFromRight} 200ms cubic-bezier(0.2, 0.8, 0.2, 1);
  }
  &[data-nav-enter="left"] {
    animation: ${slideFromLeft} 200ms cubic-bezier(0.2, 0.8, 0.2, 1);
  }
`;
